
import React from 'react';
import { courses } from '../../data/courses';
import { Clock, BarChart, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import Reveal from '../ui/Reveal';

const CoursesSection: React.FC = () => {
  return (
    <section className="py-16 bg-infinity-black">
      <div className="max-w-7xl mx-auto px-4">
        <Reveal className="text-center mb-12">
          <h2 className="text-4xl font-bold text-infinity-white mb-4">
            <span className="text-infinity-yellow">Capacitaciones</span> Profesionales
          </h2>
          <p className="text-xl text-infinity-white/70 max-w-3xl mx-auto">
            Desarrolla tus habilidades con nuestros cursos especializados en energía renovable
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {courses.map((course, index) => (
            <Reveal key={course.id} delay={index * 100}>
              <div className="group bg-infinity-dark rounded-lg shadow-lg overflow-hidden card-hover border border-transparent hover:border-infinity-yellow/40 h-full">
                <div className="overflow-hidden">
                  <img
                    src={course.image}
                    alt={course.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>

                
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-infinity-yellow mb-3">{course.title}</h3>
                  <p className="text-infinity-white/70 mb-4">{course.description}</p>

                  <div className="flex items-center space-x-6 mb-6 text-sm text-infinity-white/60">
                    <div className="flex items-center space-x-1">
                      <Clock size={16} />
                      <span>{course.duration}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <BarChart size={16} />
                      <span>{course.level}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Users size={16} />
                      <span>Certificado</span>
                    </div>
                  </div>

                  <div className="flex items-center justify-between">
                    <Link
                      to={`/capacitaciones/${course.id}`}
                      className="btn-primary hover:scale-105 hover:shadow-glow transition-all duration-300"
                    >
                      Inscribirse
                    </Link>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="text-center mt-12">
          <Link
            to="/capacitaciones"
            className="btn-secondary text-lg py-3 px-8 hover:scale-105 hover:shadow-glow transition-all duration-300"
          >
            Ver Todos los Cursos
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default CoursesSection;
